import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, unref as _unref, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "catalog" };
const _hoisted_2 = { class: "data-table__title data-table__title--muted" };
const _hoisted_3 = { class: "data-table__value-text" };
const _hoisted_4 = { class: "catalog__badges" };
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import DataTable from "@astina/paloma-common-ui/src/components/DataTable.vue";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
import productRepository from '@astina/paloma-shop-common-ui/src/services/ProductRepository';
import products from '@astina/paloma-shop-common-ui/src/services/ProductRepository';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CatalogItemActions from "@astina/paloma-shop-common-ui/src/components/CatalogItemActions.vue";
import CurrentlyUnavailable from "../components/CurrentlyUnavailable.vue";
import CatalogCategorySelection from "../components/CatalogCategorySelection.vue";
import BadgeComponent from "@astina/paloma-common-ui/src/components/BadgeComponent.vue";
import trans from '@astina/paloma-common-ui/src/services/Translator';
import { addCartItems } from "../commands/AddCartItems";
import { addWatchlistItem } from "../commands/AddWatchlistItems";
import config from "../services/PortalConfig";
import CatalogExportButtons from "../components/CatalogExportButtons.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogCategoryViewV1',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const searchRequest = ref({
            query: null,
            filters: []
        });
        const enforceSearchRequest = ref(false);
        const searchQueryPlaceholder = ref(null);
        const grid = ref(null);
        const source = ref(productRepository.getGridItemsSource());
        const categoryCode = ref(undefined);
        const category = ref(null);
        const error = ref(false);
        const allowOrderingUnitSelection = ref(config.articleOrderingUnitSelection === 'allow');
        const addCartItemsFunction = addCartItems;
        const addWatchlistItemFunction = addWatchlistItem;
        init();
        // hack: depending on how we navigate, we might get an empty string from
        //   the router. Thanks to all the changes from PALO-2708, this seems to
        //   happen only for some URLs when following a link from the outside, or
        //   reloading the page. We don't like those empty strings because when
        //   activating a router link to the main category, the 'category' param
        //   changes to `undefined`, leading to a grid refresh.
        if (route.params['category'] === '') {
            delete route.params['category'];
        }
        watch(() => route.params['category'], onCategoryOrWatchlistChange);
        watch(() => route.query['search'], onCategoryOrWatchlistChange);
        watch(() => route.query['watchlist'], onCategoryOrWatchlistChange);
        watch(() => route.query['sku'], onCategoryOrWatchlistChange);
        function onCategoryOrWatchlistChange() {
            grid.value = null;
            init();
        }
        function init() {
            if (RouterUtils.singleParam(route, 'category') === '') {
                delete route.params['category'];
            }
            categoryCode.value = RouterUtils.singleParam(route, 'category');
            const searchQuery = route.query['search'];
            if (searchQuery) {
                searchRequest.value.query = searchQuery;
                searchRequest.value.filters = [];
                enforceSearchRequest.value = true;
            }
            const watchlist = route.query['watchlist'];
            if (watchlist) {
                searchRequest.value.filters = [{
                        attribute: 'watchlist',
                        values: [watchlist],
                    }];
                enforceSearchRequest.value = true;
            }
            loadGrid();
            if (categoryCode.value) {
                products
                    .getCategory(categoryCode.value)
                    .then(c => {
                    category.value = c;
                    searchQueryPlaceholder.value = trans('catalog.search_in', { in: c.name });
                    if (route.name === 'catalog_category') {
                        RouterUtils.setPageTitle(category.value.name);
                    }
                })
                    .catch(onCategoryNotFound);
            }
            else {
                category.value = null;
                searchQueryPlaceholder.value = null;
            }
        }
        const exportSearchRequest = computed(() => {
            const sr = searchRequest.value;
            if (categoryCode.value) {
                const mainCategoryAttribute = sr.filters.filter(f => f.attribute == '_main_category');
                if (!mainCategoryAttribute || mainCategoryAttribute.length == 0) {
                    sr.filters.push({
                        attribute: '_main_category',
                        values: [categoryCode.value],
                    });
                }
            }
            return sr;
        });
        function loadGrid() {
            error.value = false;
            if (categoryCode.value) {
                source.value = productRepository.getCategoryGridItemsSource(categoryCode.value);
            }
            else {
                source.value = productRepository.getGridItemsSource();
            }
            productRepository
                .getGridConfig(categoryCode.value)
                .then(initGrid)
                .catch(() => {
                error.value = true;
            });
        }
        function initGrid(gridParam) {
            searchRequest.value.filters = searchRequest.value.filters.filter(filter => filter.attribute === "watchlist"); //hacky reset 'empty' filter except watchlist
            gridParam.filters = gridParam.filters
                .map(f => {
                if (categoryCode.value && f.name === 'cat__' + categoryCode.value) {
                    // HACK add as 'empty' filter (only works if no user settings exist for this data table)
                    if (!searchRequest.value.filters.find(rf => rf.attribute === f.name)) {
                        searchRequest.value.filters.push({
                            attribute: f.name,
                            values: [],
                        });
                    }
                }
                return f;
            });
            grid.value = gridParam;
        }
        function activateItem(item) {
            if (!item) {
                closeDetailView();
            }
            else {
                router.push({
                    name: 'catalog_category_product',
                    params: catalogCategoryProductParams(item.id)
                }).catch(() => {
                });
            }
        }
        function onCategoryNotFound() {
            router.push({ name: 'catalog' });
        }
        function mainCategoryChanged() {
            loadGrid();
        }
        function onSearchRequestChanged(searchRequestParam) {
            searchRequest.value = searchRequestParam;
        }
        function catalogCategoryProductParams(productId) {
            const params = { id: productId };
            // for whatever reason, the router behaves differently for params { }
            //   and { category: undefined }. The latter will call the route with
            //   category '', which is different from undefined triggers a grid
            //   refresh.
            if (categoryCode.value) {
                params['category'] = categoryCode.value;
            }
            return params;
        }
        // ---
        function closeDetailView() {
            const params = {};
            if (categoryCode.value) {
                params['category'] = categoryCode.value;
            }
            router.push({ name: 'catalog_category', params });
        }
        function selectNextItem() {
            events.$emit('catalog.nav-next');
        }
        function selectPrevItem() {
            events.$emit('catalog.nav-prev');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !grid.value && !error.value
                }, null, 8, ["loading"]),
                _cache[10] || (_cache[10] = _createTextVNode()),
                (!grid.value && error.value)
                    ? (_openBlock(), _createBlock(CurrentlyUnavailable, { key: 0 }))
                    : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createTextVNode()),
                (grid.value)
                    ? (_openBlock(), _createBlock(DataTable, {
                        key: 1,
                        name: "catalog",
                        title: '',
                        "search-request": searchRequest.value,
                        "enforce-search-request": enforceSearchRequest.value,
                        "search-query-placeholder": searchQueryPlaceholder.value ?? undefined,
                        grid: grid.value,
                        source: source.value,
                        "user-settings-suffix": categoryCode.value ? 'catalog-category-' + categoryCode.value : undefined,
                        onActivateItem: activateItem,
                        onPrimarySearchFilterChanged: mainCategoryChanged,
                        onSearchRequestChanged: onSearchRequestChanged
                    }, {
                        title: _withCtx(() => [
                            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('catalog')), 1),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            _createVNode(CatalogCategorySelection, { category: category.value }, null, 8, ["category"])
                        ]),
                        actions: _withCtx(() => [
                            _createVNode(CatalogExportButtons, {
                                "search-request": exportSearchRequest.value,
                                version: "v1"
                            }, null, 8, ["search-request"])
                        ]),
                        "list-item": _withCtx((props) => [
                            _createVNode(_component_router_link, {
                                to: { name: 'catalog_category_product', params: catalogCategoryProductParams(props.item.id) },
                                class: "data-table__value catalog__list-item-value",
                                style: _normalizeStyle(props.item.attributes['_main_image'] ? 'background-image: url(' + props.item.attributes['_main_image'] + ')' : '')
                            }, {
                                default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(props.item.topic), 513), [
                                        [_vShow, props.item.topic]
                                    ]),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(props.item.title), 1),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(BadgeComponent, { variant: "item-number" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.item.id), 1)
                                            ]),
                                            _: 2
                                        }, 1024),
                                        _cache[4] || (_cache[4] = _createTextVNode()),
                                        _createVNode(BadgeComponent, { variant: "price" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.item.attributes['_price']), 1)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["to", "style"])
                        ]),
                        "item-actions": _withCtx((props) => [
                            (_ctx.$isGranted('PORTAL_ORDERS_CREATE'))
                                ? (_openBlock(), _createBlock(CatalogItemActions, {
                                    key: 0,
                                    item: props['item'],
                                    "add-cart-items": _unref(addCartItemsFunction),
                                    "allow-ordering-unit-selection": allowOrderingUnitSelection.value,
                                    "add-watchlist-item": _unref(addWatchlistItemFunction)
                                }, null, 8, ["item", "add-cart-items", "allow-ordering-unit-selection", "add-watchlist-item"]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["search-request", "enforce-search-request", "search-query-placeholder", "grid", "source", "user-settings-suffix"]))
                    : _createCommentVNode("", true),
                _cache[12] || (_cache[12] = _createTextVNode()),
                _createVNode(_component_router_view, {
                    onClose: _cache[0] || (_cache[0] = ($event) => (closeDetailView())),
                    onNext: _cache[1] || (_cache[1] = ($event) => (selectNextItem())),
                    onPrev: _cache[2] || (_cache[2] = ($event) => (selectPrevItem()))
                })
            ]));
        };
    }
});
